module.exports = __webpack_public_path__ + "img/0Q3A4053_L_WoodMatted.b551ecb1.jpg";